/* eslint-disable camelcase */
export default (model, { max_aov, min_aov }) => {
  if (
      (!max_aov && !min_aov) ||
      model.aovs.length === 0
      ) return {}

  if (max_aov && min_aov) {
    const aov = model.aovs.find(aov => aov.min === min_aov && aov.max === max_aov)
    return { modelAovId: aov ? aov.id : console.log(`AOV NOT FOUND: min_aov: ${min_aov}, max_aov: ${max_aov}`) || model.aovs[0].id }
  } else if (min_aov) {
    const aov = model.aovs.find(aov => aov.min === min_aov)
    return { modelAovId: aov ? aov.id : console.log(`AOV NOT FOUND: min_aov: ${min_aov}, max_aov: ${max_aov}`) || model.aovs[0].id }
  }
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/findModelAovId.js